import { sendGTMEvent } from '@next/third-parties/google';

import type { SsoLoginResult } from '@/context/types';

// `createAccount` is the GTM trigger behind `successful_sign_up` (GA4 + UET), Meta's `CompleteRegistration`
// and the VK/Yandex `form_success` goal, so it must mean "an account was created". An SSO success is also
// what a returning user gets on a plain login, and a closed Google popup reports success with no `result`:
// only `isNewAccount` tells a signup apart.
export function trackSsoSignUp(result: SsoLoginResult | undefined): void {
  if (result?.isNewAccount) sendGTMEvent({ event: 'createAccount' });
}
